import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { CircularProgress } from "common/components/CircularProgress"
import ToastImportFacturatem from "common/components/ToastImportacionesGenerico/ToastImportFacturaExcelItem"
import useOnClickOutside from "common/hooks/useOnClickOutside"
import { useGlobalContext } from "context/_globals"
import { ImportacionFacturaProps } from "context/initialStates/_globals"
import { useEffect, useMemo, useRef, useState } from "react"
import { useTranslation } from "react-i18next"

export const TIPO_IMPORTACION = {
  SAGE: 1,
  FACTURAE: 2,
  FACTURAEXCEL: 3,
} as const

export type typeImportaciones =
  (typeof TIPO_IMPORTACION)[keyof typeof TIPO_IMPORTACION]

export const calcularSumaPorcentajesRestantes = (
  datos: ImportacionFacturaProps[]
): number =>
  datos.reduce((total, item) => {
    if (item.message) return total

    const porcentajeProcesado = Math.floor(
      (item.numeroProcesadas / item.numeroTotal) * 100
    )

    const porcentajeRestante = Math.max(0, 100 - porcentajeProcesado)

    return total + porcentajeRestante
  }, 0)

export const contarImportacionesCompletas = (
  importaciones: ImportacionFacturaProps[]
): number => {
  return importaciones.filter(
    ({ numeroProcesadas, numeroTotal }) =>
      numeroProcesadas !== undefined &&
      numeroTotal !== undefined &&
      numeroProcesadas === numeroTotal
  ).length
}
export const MenuImportacionesGenerico = () => {
  const importacionesMenuRef = useRef<HTMLDivElement>(null)
  const [importacionesMenuOpen, setImportacionesMenuOpen] =
    useState<boolean>(false)
  const { t } = useTranslation()
  const [
    {
      globals: { importacionesGenericas },
    },
  ] = useGlobalContext()

  const sumaPorcentajesRestantes = useMemo(() => {
    return 100 - calcularSumaPorcentajesRestantes(importacionesGenericas)
  }, [importacionesGenericas])

  // @ts-expect-error TS(2554): Expected 4 arguments, but got 2.
  useOnClickOutside(importacionesMenuRef, () => setImportacionesMenuOpen(false))

  useEffect(() => {
    importacionesGenericas.length > 0 && setImportacionesMenuOpen(true)
  }, [importacionesGenericas?.length])

  return (
    <div
      ref={importacionesMenuRef}
      className={`tw-hidden tw-text-left lg:tw-block tw-h-16 tw-w-0 tw-transition-all tw-duration-500 tw-overflow-hidden ${
        importacionesGenericas?.length
          ? "tw-w-16 lg:tw-border-l lg:tw-border-solid"
          : ""
      }`}
    >
      <button
        type='button'
        className='tw-flex tw-justify-center tw-w-full tw-h-16 lg:tw-text-text tw-px-7 hover:tw-text-secondary lg:hover:tw-text-text'
        onClick={() => {
          setImportacionesMenuOpen(!importacionesMenuOpen)
        }}
      >
        <span className='tw-relative tw-self-center'>
          <CircularProgress
            percent={
              Number.isNaN(sumaPorcentajesRestantes)
                ? 0
                : sumaPorcentajesRestantes
            }
            linearGradient={["#4CC8EA", "#1FC567"]}
            round
            colorCircle='#e6e6e6'
          />
          <FontAwesomeIcon
            icon={["fal", "arrow-up-from-bracket"]}
            className='tw-absolute tw-left-1/3 tw-top-1/3 tw-w-2 tw-h-2'
          />
        </span>
      </button>
      <div
        className={`${
          !importacionesMenuOpen ? "!tw-hidden" : ""
        } tw-bg-white tw-absolute tw-top-20 tw-right-96 tw-z-50 tw-shadow-md`}
      >
        <span
          className={`${
            !importacionesMenuOpen ? "tw-hidden" : ""
          } tw-flex tw-justify-between tw-items-center tw-text-lg tw-font-bold tw-text-gray-800 tw-p-4 tw-border-b`}
        >
          {t("integracion.update.title")}{" "}
          {contarImportacionesCompletas(importacionesGenericas)}/
          {importacionesGenericas.length}
        </span>
        <span className='tw-flex tw-flex-col'>
          {importacionesGenericas.map(
            (importacion: ImportacionFacturaProps) => {
              return (
                <span key={importacion.id}>
                  <ToastImportFacturatem {...importacion} />
                </span>
              )
            }
          )}
        </span>
      </div>
    </div>
  )
}
